/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';

/**
 * 
 * @export
 * @interface FunnelTableItemDto
 */
export interface FunnelTableItemDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    branchName?: string;
    /**
     * 
     * @type {ReferentialDto}
     * @memberof FunnelTableItemDto
     */
    product: ReferentialDto;
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    activeContractsCount: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelTableItemDto
     */
    quotesCount: string;
    /**
     * 
     * @type {boolean}
     * @memberof FunnelTableItemDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof FunnelTableItemDto
     */
    plateformes: Array<ReferentialDto>;
}

/**
 * Check if a given object implements the FunnelTableItemDto interface.
 */
export function instanceOfFunnelTableItemDto(value: object): value is FunnelTableItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('plateformes' in value) || value['plateformes'] === undefined) return false;
    return true;
}

export function FunnelTableItemDtoFromJSON(json: any): FunnelTableItemDto {
    return FunnelTableItemDtoFromJSONTyped(json, false);
}

export function FunnelTableItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelTableItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'code': json['code'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'product': ReferentialDtoFromJSON(json['product']),
        'activeContractsCount': json['activeContractsCount'],
        'quotesCount': json['quotesCount'],
        'isActive': json['isActive'],
        'plateformes': ((json['plateformes'] as Array<any>).map(ReferentialDtoFromJSON)),
    };
}

export function FunnelTableItemDtoToJSON(json: any): FunnelTableItemDto {
    return FunnelTableItemDtoToJSONTyped(json, false);
}

export function FunnelTableItemDtoToJSONTyped(value?: FunnelTableItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'code': value['code'],
        'branchName': value['branchName'],
        'product': ReferentialDtoToJSON(value['product']),
        'activeContractsCount': value['activeContractsCount'],
        'quotesCount': value['quotesCount'],
        'isActive': value['isActive'],
        'plateformes': ((value['plateformes'] as Array<any>).map(ReferentialDtoToJSON)),
    };
}

